import { LoadBlogDetailPagePayload, LoadBlogListPagePayload } from './types'

export const LOAD_BLOG_LIST_PAGE = 'LOAD_BLOG_LIST_PAGE'
export const LOAD_BLOG_DETAIL_PAGE = 'LOAD_BLOG_DETAIL_PAGE'

export function loadBlogListPage(payload: LoadBlogListPagePayload) {
  return {
    type: LOAD_BLOG_LIST_PAGE,
    payload,
  }
}

export function loadBlogDetailPage(payload: LoadBlogDetailPagePayload) {
  return {
    type: LOAD_BLOG_DETAIL_PAGE,
    payload,
  }
}
